import React from "react";
import { Italic } from "./_primitives";
import { Sprout, ArrowRight } from "lucide-react";

export default function FinalCTA({ onOpenPitch, onOpenInvest }) {
  return (
    <section
      id="contact"
      data-testid="final-cta-section"
      className="bg-[#0F2818] text-white relative overflow-hidden"
    >
      {/* Glow */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-[#B8D958]/10 blur-[140px] pointer-events-none" />
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none">
        <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full">
          <defs>
            <pattern id="cgrid" width="6" height="6" patternUnits="userSpaceOnUse">
              <path d="M 6 0 L 0 0 0 6" fill="none" stroke="#B8D958" strokeWidth="0.25" />
            </pattern>
          </defs>
          <rect width="100" height="100" fill="url(#cgrid)" />
        </svg>
      </div>

      <div className="max-w-5xl mx-auto px-6 lg:px-10 py-24 lg:py-36 relative z-10 text-center">
        <div className="flex justify-center mb-8">
          <img
            src="/sparkseed-logo-stacked-white.png"
            alt="SparkSeed Ventures"
            className="h-32 lg:h-40 w-auto"
            style={{ filter: "drop-shadow(0 0 18px rgba(184,217,88,0.25))" }}
          />
        </div>

        <h2 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight font-bold">
          This isn't investment.
          <br />
          This is a <Italic className="text-[#B8D958]">movement</Italic>.
        </h2>
        <p className="mt-8 text-lg lg:text-xl text-white/70 max-w-2xl mx-auto leading-relaxed">
          We fund the fighters. The builders. The crazy ones with impossible goals.
        </p>
        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-3 max-w-3xl mx-auto text-sm lg:text-base text-white/75">
          {[
            "First cheque from idea stage",
            "Operator mentors embedded Day 0",
            "Follow-on through Series B+",
            "No pedigree filter — only potential",
          ].map((t, i) => (
            <li key={i} className="flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full bg-[#B8D958]" />
              {t}
            </li>
          ))}
        </ul>

        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
          <button
            data-testid="final-cta-pitch"
            onClick={onOpenPitch}
            className="group inline-flex items-center justify-center gap-2 bg-[#B8D958] text-[#0F2818] hover:bg-[#a8c948] font-semibold rounded-full px-8 py-4 transition-all hover:-translate-y-0.5 hover:shadow-2xl hover:shadow-[#B8D958]/30"
          >
            Pitch Your Startup
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </button>
          <button
            data-testid="final-cta-invest"
            onClick={onOpenInvest}
            className="inline-flex items-center justify-center gap-2 border border-white/30 text-white hover:bg-white/5 font-semibold rounded-full px-8 py-4 transition-all"
          >
            Invest With Us
          </button>
        </div>
      </div>
    </section>
  );
}
